import {BaseContainerModel} from '../../base-container.model';
import {
   single_event_expenses_report_line_RowClass,
} from '../../../dbschema';

export class SingleEventExpensesReportsContainerModel extends BaseContainerModel {
  event_expenses_report_line: single_event_expenses_report_line_RowClass = new single_event_expenses_report_line_RowClass();
}
